// Import controller
import getAnnouncementList from 'controllers/announcement/getAnnouncementList'

// Fetch Announcement Actions
export const START_FETCH_ANNOUNCEMENT_LIST = 'START_FETCH_ANNOUNCEMENT_LIST'
export const SUCCESS_FETCH_ANNOUNCEMENT_LIST = 'SUCCESS_FETCH_ANNOUNCEMENT_LIST'
export const FAILED_FETCH_ANNOUNCEMENT_LIST = 'FAILED_FETCH_ANNOUNCEMENT_LIST'

// Fetch Action Creator
export function fetchAnnouncementList(obj){
  return function(dispatch) {

    dispatch({
      type: START_FETCH_ANNOUNCEMENT_LIST,
      payload: {fetching: true}
    })

    getAnnouncementList(obj)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_ANNOUNCEMENT_LIST,
        payload: {...result, fetching: false, hasPermission: true}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_ANNOUNCEMENT_LIST,
        payload: {error: err, fetching: false, hasPermission: false}
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/redux/actions/getAnnouncementList.js